/* Novo Selo Winery — AJAX cart drawer */
(function () {
  var root = document.getElementById('CartDrawer');
  if (!root) return;
  var threshold = parseInt(root.dataset.threshold || '0', 10);
  var msgRemaining = root.dataset.msgRemaining || '';
  var msgDone = root.dataset.msgDone || '';
  var itemsEl = root.querySelector('.cd-items');
  var emptyEl = root.querySelector('.cd-empty');
  var totalEl = root.querySelector('.cd-total');
  var countEl = root.querySelector('.cd-count');
  var fsEl = root.querySelector('.cd-fs');
  var fsMsg = root.querySelector('.cd-fs-msg');
  var fsBar = root.querySelector('.cd-fs-bar span');
  var checkoutBtn = root.querySelector('.cd-checkout');
  var upsell = root.querySelector('.cd-upsell');
  var upsellId = upsell ? parseInt(upsell.dataset.variant, 10) : 0;
  
  function money(cents) { return (cents / 100).toFixed(2) + ' €'; }

  function headerCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function render(cart) {
    headerCount(cart.item_count);
    countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    totalEl.textContent = money(cart.total_price);
    var has = cart.items.length > 0;
    emptyEl.hidden = has;
    checkoutBtn.style.display = has ? '' : 'none';
    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_160x$1$2') : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cdi-var">' + it.variant_title + '</div>' : '';
      return '<div class="cdi" data-line="' + (i + 1) + '">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="cdi-noimg"></span>') +
        '<div class="cdi-info"><a class="cdi-name" href="' + it.url + '">' + it.product_title + '</a>' + vt +
        '<div class="cdi-row"><span class="cdi-qty"><button type="button" data-cd-minus aria-label="−">−</button><b>' + it.quantity + '</b><button type="button" data-cd-plus aria-label="+">+</button></span>' +
        '<span class="cdi-price">' + money(it.final_line_price) + '</span></div></div>' +
        '<button type="button" class="cdi-x" data-cd-remove aria-label="Премахни">&times;</button></div>';
    }).join('');
    if (threshold > 0 && has) {
      fsEl.hidden = false;
      var remaining = threshold - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price * 100 / threshold));
      fsMsg.textContent = remaining > 0 ? msgRemaining.replace('[amount]', money(remaining)) : '✓ ' + msgDone;
      fsMsg.classList.toggle('done', remaining <= 0);
      fsBar.style.width = pct + '%';
    } else { fsEl.hidden = true; }
    if (upsell) {
      var inCart = cart.items.some(function (it) { return it.variant_id === upsellId; });
      upsell.hidden = !has || inCart;
    }
  }

  function refresh(open) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      render(cart);
      if (open) show();
      return cart;
    });
  }

  function show() { root.classList.add('open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function hide() { root.classList.remove('open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) { hide(); return; }
    var line = e.target.closest('.cdi');
    if (!line) return;
    var n = parseInt(line.dataset.line, 10);
    var qty = parseInt(line.querySelector('.cdi-qty b').textContent, 10);
    var next = null;
    if (e.target.closest('[data-cd-plus]')) next = qty + 1;
    else if (e.target.closest('[data-cd-minus]')) next = Math.max(0, qty - 1);
    else if (e.target.closest('[data-cd-remove]')) next = 0;
    if (next === null) return;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: n, quantity: next })
    }).then(function (r) { return r.json(); }).then(render);
  });

  if (upsell) {
    var upBtn = upsell.querySelector('.cd-up-add');
    var upLabel = upBtn.textContent;
    upBtn.addEventListener('click', function () {
      upBtn.disabled = true; upBtn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: upsellId, quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw 0; return refresh(false); })
        .catch(function () {})
        .finally(function () { upBtn.disabled = false; upBtn.textContent = upLabel; });
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });

  /* intercept every add-to-cart form (product cards, product page, sticky bar) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { return refresh(true); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  }, true);

  /* header cart icon opens the drawer */
  document.querySelectorAll('.header-icons a[href*="/cart"]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
  });

  refresh(false);
})();
